"use client";

import { useRouter } from "next/navigation";

export default function ScrollToFormButton({ mobile }: { mobile?: boolean } = {}) {
      const router = useRouter();

      const handleScroll = () => {
            const formElement = document.getElementById("treatment-contact-form");

            if (formElement) {
                  formElement.scrollIntoView({ behavior: "smooth", block: "center" });

                  formElement.classList.add("ring-4", "ring-[#A68F72]/50", "scale-[1.02]");
                  setTimeout(() => {
                        formElement.classList.remove("ring-4", "ring-[#A68F72]/50", "scale-[1.02]");
                  }, 1500);
            } else {
                  router.push("/iletisim");
            }
      };

      if (mobile) {
            return (
                  <button
                        onClick={handleScroll}
                        className="col-span-2 flex items-center justify-center gap-2 bg-[#A68F72] text-white py-3.5 rounded-xl font-bold text-sm active:scale-95 transition-all"
                  >
                        Hemen Başvur <span className="text-base">→</span>
                  </button>
            );
      }

      return (
            <button
                  onClick={handleScroll}
                  className="inline-flex items-center justify-center w-full bg-white text-[#A68F72] py-3 rounded-xl font-bold hover:bg-gray-100 transition-all shadow-md relative z-10 active:scale-95"
            >
                  Hemen İletişime Geç
            </button>
      );
}